import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzAlertComponent } from "ng-zorro-antd/alert";
import { UiAlertType } from "@webapp/ui/alert/alert.models";

@Component({
  selector: "ui-alert",
  exportAs: "uiAlert",
  templateUrl: "alert.component.html",
})
export class UiAlertComponent extends NzAlertComponent {
  @Input("uiCloseText") public nzCloseText: string | TemplateRef<void> | null = null;
  @Input("uiIconType") public nzIconType: string | null = null;
  @Input("uiMessage") public nzMessage: string | TemplateRef<void> | null = null;
  @Input("uiDescription") public nzDescription: string | TemplateRef<void> | null = null;
  @Input("uiType") public nzType: UiAlertType = "info";
  @Input("uiCloseable") @WithConfig() @InputBoolean() public nzCloseable = false;
  @Input("uiShowIcon") @WithConfig() @InputBoolean() public nzShowIcon = false;
  @Input("uiBanner") @InputBoolean() public nzBanner = false;
  @Output("uiOnClose") public readonly nzOnClose = new EventEmitter<boolean>();
}
